import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "theme-light" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center text-sm text-grey text-opacity-30"
}
const _hoisted_4 = {
  key: 1,
  class: "flex space-x-2 justify-center"
}
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center text-sm text-grey text-opacity-30"
}
const _hoisted_6 = {
  key: 1,
  class: "flex justify-center text-sm text-grey text-opacity-30"
}
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center text-sm text-grey text-opacity-30"
}
const _hoisted_8 = {
  key: 1,
  class: "flex justify-center text-sm text-grey text-opacity-30"
}
const _hoisted_9 = {
  key: 0,
  class: "navigation-area z-20 bg-greyLight"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = {
  key: 0,
  class: "absolute -top-1.5 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-red px-1 text-[10px] font-semibold leading-none text-white"
}
const _hoisted_13 = { class: "text-[10px] text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_no_internet = _resolveComponent("no-internet")!
  const _component_error_modal = _resolveComponent("error-modal")!
  const _component_install_modal = _resolveComponent("install-modal")!
  const _component_NewVersionModal = _resolveComponent("NewVersionModal")!
  const _component_BlockedModal = _resolveComponent("BlockedModal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_no_internet),
    _createVNode(_component_error_modal),
    _createVNode(_component_install_modal),
    _createElementVNode("div", {
      class: "fixed top-0 z-[49] w-full bg-background",
      style: _normalizeStyle({ height: _ctx.iosPlatformHeight })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.appName && _ctx.isBrand.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.appName), 1))
        : _createCommentVNode("", true),
      (_ctx.platformApp === 'Android' || _ctx.platformApp === 'IOS')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.platformApp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.platformApp), 1))
              : _createCommentVNode("", true),
            (_ctx.appVersion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " v" + _toDisplayString(_ctx.currentAppVersion), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex justify-center select-none", _ctx.currentRoutePath == '/notifications' ? 'space-x-2' : ''])
      }, [
        (_ctx.userData && _ctx.userData.phone_number && _ctx.currentRoutePath != '/')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.currentRoutePath != "/notifications"
              ? ""
              : "Выплаты аккаунта: " + _ctx.userData.phone_number), 1))
          : _createCommentVNode("", true),
        (_ctx.platformApp === 'Pwa' || _ctx.platformApp === 'Web')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.platformApp), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, { include: ['HomeView', 'LoginPage', 'TelegramBanner'] }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 2
        }, 1024),
        (_ctx.showNewVersionModal && _ctx.isOnline)
          ? (_openBlock(), _createBlock(_component_NewVersionModal, {
              key: 0,
              onDecline: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideNewVersionModal()))
            }))
          : _createCommentVNode("", true),
        (_ctx.isBrand.length && _ctx.brandIsActivate === false)
          ? (_openBlock(), _createBlock(_component_BlockedModal, {
              key: 1,
              class: "absolute top-[50%] translate-y-[-50%] w-full h-full"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.layout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationTabs, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.onClickTab(tab.route)),
              class: _normalizeClass(["tab", { 'tab-active': tab.route === _ctx.currentRoute }]),
              style: _normalizeStyle(
          _ctx.hasBottomPadding ? `padding-bottom: ${_ctx.navigationBottomPadding}px` : ''
        ),
              key: tab.icon
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["tab-icon text-darkGrey", { 'text-greyLight': tab.route === _ctx.currentRoute }])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(tab.icon)
                  }, null, 2)
                ], 2),
                (tab.route === '/documents' && _ctx.newDocumentsCount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.newDocumentsCount), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(tab.title), 1)
            ], 14, _hoisted_10))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}